<template>
  <div class="bj-container">
    <div class="side">
      <HundredSubject
        @subClick="handleSub"
        @requestAll="handleAll"
        title="期刊分类"
      ></HundredSubject>
    </div>
    <div class="content">
      <template v-if="total > 0 || scrollFlag">
        <ProjectItem :projectList="projectList"/>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
      </template>
      <NoData v-if="total <= 0 && !scrollFlag"></NoData>
    </div>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
import ProjectItem from "./components/ProjectItem.vue";
import HundredSubject from "./components/HundredSubject.vue";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    ProjectItem,
    HundredSubject,
    NoData,
    Scroll
  },
  data() {
    return {
      isEnd: false,
      scrollFlag: false,
      filterFlag: false,
      projectList: [],
      pageNum: 1,
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getSectionList(this.params); // 百科
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    handleAll() {
      this.curPage = 2;
      this.projectList = [];
      this.filterFlag = false;
      delete this.params.levelTwoCodes;
      // 请求全部
      this.getSectionList(this.params);
    },
    handleSub(v) {
      console.log(v)
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.projectList = [];
      }
      this.params.levelTwoCodes = [v.code];
      this.getSectionList({
        ...this.params,
      });
    },
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd ) {
        if (this.filterFlag) {
          this.getSectionList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        } else {
          this.getSectionList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        }
      }
    },
    async getSectionList(data) {
      this.scrollFlag = true
      this.isEnd = false
      const resp = await this.$apis.hundredServe.getSectionList(data);
      this.total = +resp.periodicalList.total;
      this.projectList.push(...resp.periodicalList.list);
      this.scrollFlag = false
      this.isEnd = this.pageNum >= this.total / 10
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/public.scss";
::v-deep .ivu-tree-empty {
  margin: 30px;
}
.ivu-tree {
  margin: 0 13px;
}
.bj-container {
  display: flex;
  .side {
    width: 300px;
    height: 559px;
    background-color: #fff;
  }
  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .content {
    margin-top: 25px;
    width: 900px;
    position: relative;
  }
}
</style>
